import React from 'react';
import { Search, Filter, SortAsc } from 'lucide-react';

interface DealFiltersProps {
  onSearch: (term: string) => void;
  onFilterChange: (filter: string) => void;
  onSortChange: (sort: string) => void;
}

export default function DealFilters({ onSearch, onFilterChange, onSortChange }: DealFiltersProps) {
  return (
    <div className="flex gap-4 mb-6">
      <div className="flex-1 relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="text"
          placeholder="Search deals..."
          onChange={(e) => onSearch(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <select
        onChange={(e) => onFilterChange(e.target.value)}
        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">All Types</option>
        <option value="acquisition">Acquisition</option>
        <option value="merger">Merger</option>
        <option value="divestiture">Divestiture</option>
      </select>

      <select
        onChange={(e) => onSortChange(e.target.value)}
        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="value">Value</option>
        <option value="date">Date</option>
        <option value="name">Name</option>
      </select>
    </div>
  );
}